
import KeyboardOpen from "../../../assets/duotone/KeyboardOpen.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function KeyboardOpenIcon({ className, dataTestid = "KeyboardOpenIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <KeyboardOpen data-testid={dataTestid} className={classes} {...rest} />
  );
}
